import React, {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faShield} from "@fortawesome/free-solid-svg-icons";

class DatenschutzPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            props: props,
        };
    }

    render() {
        return (
            <div className="page overflow-hidden">
                <div className="header">
                    <div className="title text-center mt-4 mb-4">
                        <h2 style={{ color: '#021260', fontWeight: 'bold' }}>
                            <FontAwesomeIcon icon={faShield} style={{ marginRight: '0.5rem' }} />
                            Datenschutz – Digitales Arbeitsblatt
                        </h2>
                    </div>
                </div>
                <div className="content">
                    <div className="container">
                        <div className="card" style={{
                            borderRadius: '1em',
                            boxShadow: 'rgba(0, 0, 0, 0.18) 0px 2px 4px',
                            padding: '2em',
                            marginBottom: '2em',
                            background: '#f5f5f5',
                            borderLeft: '5px solid #021260'
                        }}>
                            <div className="card-body">
                                <p className="mb-4 fs-5 fw-semibold" style={{ color: '#021260' }}>
                                    Detaillierte Informationen zum Datenschutz finden Sie auf unserer Website unter:
                                </p>
                                <div className="text-center mb-4">
                                    <a
                                        href="https://bau-abc-rostrup.de/datenschutz"
                                        className="link-primary fw-bolder text-decoration-none fs-5"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        https://bau-abc-rostrup.de/datenschutz
                                    </a>
                                </div>
                            </div>
                            <div className="text-center fst-italic fw-semibold" style={{ color: 'var(--bs-gray-700)' }}>
                                Stand: {new Date().toLocaleDateString('de-DE', { year: 'numeric', month: 'long' })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer mt-5">

                </div>
                <div className="disclaimer mt-5">
                    <span>my.ausbildung.cloud</span>
                </div>
            </div>
        )
    }
}

export default DatenschutzPage;
